import React from 'react';
import HeaderProfile from '../../../../components/header_Profile/header_Profile.index';
import NewPatientPharmacyForm from './NewPatientPharmacyForm';

const NewPatientInvoice: React.FC = () => {
  return (
    <>
      <HeaderProfile />
      <NewPatientPharmacyForm />
    </>
  );
};

export default NewPatientInvoice;

